import { PaymentType, ProviderGeneralDataApiResponse, ProviderSettingsApiResponse, Voucher } from '@shared/models';

export const exampleOpenCosts: any[] = [
  {
    amount: '47.39',
    currency: 'EUR',
  },
];

export const exampleLicensePlates: any[] = [
  {
    license_plate_country: 'D',
    license_plate: 'D:EMO1',
  },
  {
    license_plate_country: 'A',
    license_plate: 'D:EMO2',
  },
  {
    license_plate_country: 'D',
    license_plate: 'D:EMO3',
  },
];

export const examplePayPerUseLicensePlates: any[] = [
  {
    license_plate_country: 'D',
    license_plate: 'D:EMO1',
    pay_per_use_enabled: true,
  },
  {
    license_plate_country: 'A',
    license_plate: 'D:EMO2',
    pay_per_use_enabled: true,
  },
  {
    license_plate_country: 'D',
    license_plate: 'D:EMO3',
    pay_per_use_enabled: false,
  },
];

export const exampleGarageContracts: any[] = [
  {
    id: '1',
    bookable: 'internal',
    name: '24h Dauerparken (Beispielvertrag)',
    product_id: '1',
    garage: {
      name: 'Freyung Parkgarage',
      street: 'Herrengasse',
      number: '',
      zip_code: '1010',
      city: 'Wien',
    },
    group_limit: 2,
    license_plates: [...exampleLicensePlates],
    price: { amount: '100.12', currency: 'EUR' },
    reference: 'ABC123457ABC123457ABC123 457ABC123457ABC123457',
    withdrawable: false,
    start: '2022-01-01',
    end: '2022-12-12',
    minimum_duration_months: 12,
    notice_period_months: 1,
    price_adjustment: {
      month_start: 2,
      month_end: 10,
      type: 'percentage',
      amount: 10,
    },
    qr_src:
      'data:image/png;base64,isVBORw0KGgoAAAANSUhEUgAAAPoAAAD6AQAAAACgl2eQAAABsUlEQVR4nO2YMc7cIBCFvwlIW2JpD5CjsFfLzfBR9gCRTI/1UgDOH6WIt9nAylSAv+Jp9DzMDLTl1FdB2vo13/jHuoAOREnSBvZgN7MFOAI7isg5gGxmj3pykp6+7s3Mv03DZwH6sQDr4vT/NHwGYA92A/bDou/XMDcQJCWA+LwJQqlfJJVxRI4PeFYDwNWzxedNRnXnmzR8BuD151nk3QT9eh1B5BQAEFoBWUvJhKtFEXEDpRFETgGgFAotWQaJqEKtMVMoVyTPA8162pyIkmpMa1E+jMgpAIib05cfO+FE7IG9PHkaoJlwo3fbtSjq4RxC5BRAe2xasiw0O25Qa8whRE4BtL87AfUVT6GlyLYbQeQUwF92BKgvTtT1dr8AeCOAyJ7WKIafvvU3+S4bQuQUAMeAt7XcsdqxV5ZDiJwC6P7DFcg3QV6AfC+Auzz5CnDMzNvwJ3R3ks1GETkHcMzM12U3yB5WMwPcVZmfB/zvrcUNWUwFYtq91u9XnnwB+BJJreaKyPei1ZyMAFeePA14CAIyGGHD6sw3bBAT6JpPngWO1RrtWqjX4cW7NHwG8AvQtRJo4AUP9wAAAABJRU5ErkJggg==',
  },
  {
    id: '2',
    bookable: 'information',
    name: 'Nachtparken (Beispielvertrag)',
    product_id: '2',
    withdrawable: true,
    garage: {
      name: 'Liechtensteinstraße 4 Parkgarage',
      street: null,
      number: null,
      zip_code: null,
      city: null,
    },
    group_limit: 1,
    license_plates: [exampleLicensePlates[0], exampleLicensePlates[1]],
    price: { amount: '150', currency: 'EUR' },
    reference: 'Customer no.1',
    reference_label: "Customer Number",
    start: '2024-07-30T14:00:00',
    end: null,
    minimum_duration_months: 12,
    notice_period_months: 1,
    price_adjustment: {
      month_start: 10,
      month_end: 10,
      type: 'absolute',
      amount: {
        amount: '10',
        currency: 'EUR',
      },
    },
    qr_src:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAD6AQAAAACgl2eQAAABr0lEQVR4nO2ZMY7jMBAEq4/MKeAe4KdQX9ufSU/ZByxA5xL6AlK2Nzo72SUNTSBIZAUNAjPsGUGLYNsbkGy7HMv84T9xAgeQ3Y5OmsAuuzTXg7V7ETkGcJU0A+QSfN+RFH9MwxsA8f7qdSq/ouHtAM3sYp1+U8PAAEedDCaXUCumXc46+TqwSpKm9q2ZYM3skiT1InIAIPrxaxcAhmN57UHkEACQNlpO2waCyQXIBbz0IHIMwMs1wnqxa4pnb3XHH5etF5EjAFEAyp+qCd2sUDKCiLoQOQRQ7+76gODaLS6prZ3Z/TTA3fvU6njvu2vL04PIIQC8EOwlbXhJGw8X0NKNyCGAqOxd5M8IXCMGLJKBVM46+TwQvSrUo1M2iFRuZnKPPv3ks0CNmuKud09zQWedfA2ofvww5QDpfpX/kIY3AdQiQmtvdsE1Us+0D5EjAA+zIC8cLWP1mKUXkaMAt5k5AKsirJJYL6czfwF4mJkrl7+bcplk2I+NHkQOAXz/+xDwOgHrHKy8cPrJ54FIdeHXZiVFKkD6Uhto9CByCOAWoU4wasuY3VrGPkQOAfwDW375iuc6s9UAAAAASUVORK5CYII=',
  },
  {
    id: '3',
    bookable: 'public',
    name: 'Wochenendparken (Beispielvertrag)',
    product_id: '3',
    withdrawable: true,
    garage: {
      name: 'Gonzagagasse Parkgarage',
      street: 'Gonzagagasse',
      number: '21',
      zip_code: '1010',
      city: 'Wien',
    },
    group_limit: 1,
    license_plates: [exampleLicensePlates[0]],
    price: { amount: '150', currency: 'EUR' },
    start: '2022-01-01T14:00:00',
    minimum_duration_months: 6,
    notice_period_months: 3,
  },
  {
    id: '4',
    bookable: 'public',
    name: 'Wochenendparken (Beispielvertrag)',
    withdrawable: false,
    product_id: '3',
    garage: null,
    group_limit: 1,
    license_plates: [],
    price: { amount: '150', currency: 'EUR' },
    start: '2022-01-01T14:00:00',
    minimum_duration_months: 6,
    notice_period_months: 3,
    qr_src:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAD6AQAAAACgl2eQAAABsUlEQVR4nO2YMc7cIBCFvwlIW2JpD5CjsFfLzfBR9gCRTI/1UgDOH6WIt9nAylSAv+Jp9DzMDLTl1FdB2vo13/jHuoAOREnSBvZgN7MFOAI7isg5gGxmj3pykp6+7s3Mv03DZwH6sQDr4vT/NHwGYA92A/bDou/XMDcQJCWA+LwJQqlfJJVxRI4PeFYDwNWzxedNRnXnmzR8BuD151nk3QT9eh1B5BQAEFoBWUvJhKtFEXEDpRFETgGgFAotWQaJqEKtMVMoVyTPA8162pyIkmpMa1E+jMgpAIib05cfO+FE7IG9PHkaoJlwo3fbtSjq4RxC5BRAe2xasiw0O25Qa8whRE4BtL87AfUVT6GlyLYbQeQUwF92BKgvTtT1dr8AeCOAyJ7WKIafvvU3+S4bQuQUAMeAt7XcsdqxV5ZDiJwC6P7DFcg3QV6AfC+Auzz5CnDMzNvwJ3R3ks1GETkHcMzM12U3yB5WMwPcVZmfB/zvrcUNWUwFYtq91u9XnnwB+BJJreaKyPei1ZyMAFeePA14CAIyGGHD6sw3bBAT6JpPngWO1RrtWqjX4cW7NHwG8AvQtRJo4AUP9wAAAABJRU5ErkJggg==',
  },
];

export const exampleUser: any = {
  email: 'example.email@arivo.co',
  first_name: null,
  last_name: null,
  address: null,
  zip_code: null,
  city: null,
  country: null,
  business: false,
  company_name: null,
  uid: null,
  phonenumber: null,
};

export const exampleProducts: any[] = [
  {
    id: '1',
    name: '24h Dauerparken (Beispielvertrag)',
    description: null,
    price: {
      amount: '98.0',
      currency: 'EUR',
    },
    bookable: 'public',
    min_contract_period: 12,
    approval_required: false,
    termination_period: 1,
    price_adjustment: {
      month_start: 2,
      month_end: 10,
      type: 'percentage',
      amount: 10,
    },
  },
  {
    id: '2',
    name: 'Nachtparken (Beispielvertrag)',
    description: 'Parken von 18:00 bis 08:00 Uhr',
    price: {
      amount: '50.0',
      currency: 'EUR',
    },
    bookable: 'public',
    min_contract_period: 6,
    termination_period: 1,
    approval_required: false,
    price_adjustment: {
      month_start: 7,
      month_end: 7,
      type: 'absolute',
      amount: {
        amount: '98.0',
        currency: 'EUR',
      },
    },
  },
  {
    id: '3',
    name: 'Wochenendparken (Beispielvertrag)',
    approval_required: false,
    description: 'Parken von Freitag 18:00 bis Montag 08:00 Uhr',
    price: {
      amount: '30.0',
      currency: 'EUR',
    },
    bookable: 'public',
    min_contract_period: null,
    termination_period: 1,
  },
  {
    id: '4',
    name: 'Neuer Infovertrag (Beispielvertrag)',
    description: 'Parken nur als Information',
    approval_required: false,
    price: {
      amount: '30.0',
      currency: 'EUR',
    },
    bookable: 'information',
    min_contract_period: null,
    termination_period: 1,
  },
  {
    id: '5',
    name: 'Super Vertrag beantragen (Beispielvertrag)',
    description: 'Parkplätze können nur manuell genehmigt werden.',
    price: {
      amount: '30.0',
      currency: 'EUR',
    },
    bookable: 'public',
    approval_required: true,
    min_contract_period: 3,
    termination_period: 1,
    price_adjustment: {
      month_start: 7,
      month_end: 7,
      type: 'absolute',
      amount: {
        amount: '98.0',
        currency: 'EUR',
      },
    },
  },
  {
    id: '6',
    name: 'File Vertrag beantragen (Beispielvertrag)',
    description: 'Parkplätze können nur manuell genehmigt werden.',
    price: {
      amount: '30.0',
      currency: 'EUR',
    },
    bookable: 'public',
    approval_required: true,
    min_contract_period: 3,
    termination_period: 1,
    attachment_field: {
      mandatory: false,
      title: "not_mandatory",
      description: "Dont have to fill in"
    },
    price_adjustment: {
      month_start: 7,
      month_end: 7,
      type: 'absolute',
      amount: {
        amount: '98.0',
        currency: 'EUR',
      },
    },
  },
  {
    id: '7',
    name: 'Vertrag File mandatory beantragen (Beispielvertrag) ',
    description: 'Parkplätze können nur manuell genehmigt werden.',
    price: {
      amount: '30.0',
      currency: 'EUR',
    },
    bookable: 'public',
    approval_required: true,
    attachment_field: {
      mandatory: true,
      title: "mandatory",
      description: "you better fill this one up!"
    },
    min_contract_period: 3,
    termination_period: 1,
    price_adjustment: {
      month_start: 7,
      month_end: 7,
      type: 'absolute',
      amount: {
        amount: '98.0',
        currency: 'EUR',
      },
    },
  }
];

export const exampleGarages: any[] = [
  {
    id: '1',
    name: 'Freyung Parkgarage',
    street: 'Herrengasse',
    number: '',
    zip_code: '1010',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.21155881631771,
      longitude: 16.365026225916996,
    },
  },
  {
    id: '2',
    name: 'Liechtensteinstraße 4 Parkgarage',
    street: 'Liechtensteinstraße',
    number: '4',
    zip_code: '1090',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.21604840903735,
      longitude: 16.363832630426497,
    },
  },
  {
    id: '3',
    name: 'Gonzagagasse Parkgarage',
    street: 'Gonzagagasse',
    number: '21',
    zip_code: '1010',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.216355040623974,
      longitude: 16.36921650392693,
    },
  },
  {
    id: '4',
    name: 'Beethovenplatz Parkgarage',
    street: 'Beethovenplatz',
    number: '3',
    zip_code: '1010',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.20222576206016,
      longitude: 16.377300737639715,
    },
  },
  {
    id: '5',
    name: 'Parkring Parkgarage',
    street: 'Parkring',
    number: '12a',
    zip_code: '1010',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.205231652061826,
      longitude: 16.376602057955086,
    },
  },
  {
    id: '6',
    name: 'Weihburggasse Parkgarage',
    street: 'Hegelgasse',
    number: '1',
    zip_code: '1010',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.20464917761038,
      longitude: 16.37668393748485,
    },
  },
  {
    id: '7',
    name: 'Naschmarkt Parkgarage',
    street: 'Kühnplatz',
    number: '1',
    zip_code: '1040',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.19773299356564,
      longitude: 16.364905578794318,
    },
  },
  {
    id: '8',
    name: 'Technische Uni Operngasse Parkgarage',
    street: 'Operngasse',
    number: '13',
    zip_code: '1040',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.19892138190959,
      longitude: 16.366609336042092,
    },
  },
  {
    id: '9',
    name: 'TU Campus Gußhaus Parkgarage',
    street: 'Gußhausstraße',
    number: '27',
    zip_code: '1040',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.196308662484185,
      longitude: 16.36969202370014,
    },
  },
  {
    id: '10',
    name: 'Technische Uni Lehargasse Parkgarage',
    street: 'Lehargasse',
    number: '4',
    zip_code: '1060',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.20041530069149,
      longitude: 16.363593033587133,
    },
  },
  {
    id: '11',
    name: 'Stiftgasse Parkhaus',
    street: 'Stiftgasse',
    number: '5-9',
    zip_code: '1070',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.20095290136897,
      longitude: 16.355348113071994,
    },
  },
  {
    id: '12',
    name: 'Westbahnhof Parkhaus',
    street: 'Felberstraße',
    number: '1',
    zip_code: '1150',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.19702700095822,
      longitude: 16.33537348325772,
    },
  },
  {
    id: '13',
    name: 'Viktoriagasse Parkhaus',
    street: 'Viktoriagasse',
    number: '4',
    zip_code: '1150',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.193929657461034,
      longitude: 16.332402255553905,
    },
  },
  {
    id: '14',
    name: 'Garage U3 Hütteldorfer Straße',
    street: 'Hütteldorfer Straße',
    number: '112',
    zip_code: '1140',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.19919041094897,
      longitude: 16.30990067039236,
    },
  },
  {
    id: '15',
    name: 'Pflegewohnhaus Baumgarten Parkgarage',
    street: 'Seckendorfstraße',
    number: '1',
    zip_code: '1140',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.19738950638981,
      longitude: 16.28691621485978,
    },
  },
  {
    id: '16',
    name: 'Hugo Breitner Hof Parkgarage',
    street: 'Hanakgasse',
    number: '2-4',
    zip_code: '1140',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.19810686469938,
      longitude: 16.269587952878368,
    },
  },
  {
    id: '17',
    name: 'Missindorfstraße Parkgarage',
    street: 'Missindorfstraße',
    number: '21-23',
    zip_code: '1140',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.19629043256003,
      longitude: 16.30581650575736,
    },
  },
  {
    id: '18',
    name: 'P+R Liesing Parkhaus',
    street: 'Liesinger Platz',
    number: '1',
    zip_code: '1230',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.1356875192668,
      longitude: 16.28373674111286,
    },
  },
  {
    id: '19',
    name: 'P+R Siebenhirten Parkhaus',
    street: 'Porschestraße',
    number: '25',
    zip_code: '1230',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.129327442656866,
      longitude: 16.31040398538774,
    },
  },
  {
    id: '20',
    name: 'LKH Mödling Parkplatz',
    street: 'Gabrieler Straße',
    number: '13',
    zip_code: '2340',
    city: 'Mödling',
    contract_templates: [],
    location: {
      latitude: 48.08818277101867,
      longitude: 16.295344576222263,
    },
  },
  {
    id: '21',
    name: 'Star 22 Parkgarage',
    street: 'Adelheid-Popp-Gasse',
    number: '22',
    zip_code: '1220',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.22905579837852,
      longitude: 16.458544386138968,
    },
  },
  {
    id: '22',
    name: 'Seestadt Aspern Parkgarage P3',
    street: 'Frenkel-Brunswik-Gasse',
    number: '1-3',
    zip_code: '1220',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.2241238683289,
      longitude: 16.502898701297816,
    },
  },
  {
    id: '23',
    name: 'Seestadt Aspern Parkgarage P4',
    street: 'Ilse-Arlt-Straße',
    number: '4-6',
    zip_code: '1220',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.22429702066207,
      longitude: 16.49804191657782,
    },
  },
  {
    id: '24',
    name: 'Seestadt Aspern Parkgarage P1',
    street: 'Schenk-Danzinger-Gasse',
    number: '4-6',
    zip_code: '1220',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.224841994543304,
      longitude: 16.500955979234085,
    },
  },
  {
    id: '25',
    name: 'Seestadt Aspern Parkgarage P2',
    street: 'Agnes-Primocic-Gasse',
    number: '4',
    zip_code: '1220',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.22580109647777,
      longitude: 16.501246671109058,
    },
  },
  {
    id: '26',
    name: 'Enkplatz Parkgarage',
    street: 'Enkplatz',
    number: '',
    zip_code: '1110',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.176321939728965,
      longitude: 16.41383812154674,
    },
  },
  {
    id: '27',
    name: 'Simmeringer Hauptstraße Parkgarage',
    street: 'Simmeringer Hauptstraße',
    number: '108a',
    zip_code: '1110',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.17234207413262,
      longitude: 16.417948388370878,
    },
  },
  {
    id: '28',
    name: 'Simmering U3 Parkgarage',
    street: 'Simmeringer Hauptstraße',
    number: '171',
    zip_code: '1110',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.16926847626746,
      longitude: 16.422548233372925,
    },
  },
  {
    id: '29',
    name: 'Gerhard-Bronner-Straße Parkgarage',
    street: 'Gerhard-Bronner-Straße',
    number: '7',
    zip_code: '1100',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.18343455615321,
      longitude: 16.378587180316323,
    },
  },
  {
    id: '30',
    name: 'Hauptbahnhof Wien Parkgarage',
    street: 'Gerhard-Bronner-Straße',
    number: '2 Hauptbahnhof',
    zip_code: '1100',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.184132818096764,
      longitude: 16.378732772940403,
    },
  },
  {
    id: '31',
    name: 'Neu Leopoldau P1 Parkplatz',
    street: 'Thayagasse',
    number: '3',
    zip_code: '1210',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.27350117629031,
      longitude: 16.430141742135167,
    },
  },
  {
    id: '32',
    name: 'Neu Leopoldau P2 Parkhaus',
    street: 'Simmelgasse',
    number: '2',
    zip_code: '1210',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.27657421102725,
      longitude: 16.428687645868738,
    },
  },
  {
    id: '33',
    name: 'Neu Leopoldau P3 Parkhaus',
    street: 'Tauschekgasse',
    number: '11-13',
    zip_code: '1210',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.27583398792935,
      longitude: 16.431648705589378,
    },
  },
  {
    id: '34',
    name: 'Dornerplatz Parkgarage',
    street: 'Dornerplatz',
    number: '',
    zip_code: '1170',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.22091488327673,
      longitude: 16.33404503461344,
    },
  },
  {
    id: '35',
    name: 'Geblergasse Parkgarage',
    street: 'Geblergasse',
    number: '107',
    zip_code: '1170',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.21697542510072,
      longitude: 16.32313335747462,
    },
  },
  {
    id: '36',
    name: 'Hofferplatz Parkgarage',
    street: 'Hofferplatz',
    number: '',
    zip_code: '1160',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.208920513789536,
      longitude: 16.333715740600187,
    },
  },
  {
    id: '37',
    name: 'Unizentrum Althanstraße Parkhaus',
    street: 'Augasse',
    number: '2-6',
    zip_code: '1090',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.23303650876524,
      longitude: 16.358395691079554,
    },
  },
  {
    id: '38',
    name: 'Pharmazie Parkhaus',
    street: 'Augasse',
    number: '2-6',
    zip_code: '1090',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.232596683667744,
      longitude: 16.358673023604464,
    },
  },
  {
    id: '39',
    name: 'Town Town Parkgarage',
    street: 'Schnirchgasse',
    number: '12',
    zip_code: '1030',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.19452585935334,
      longitude: 16.410568025820044,
    },
  },
  {
    id: '40',
    name: 'Windmühlgasse Parkhaus',
    street: 'Windmühlgasse',
    number: '22',
    zip_code: '1060',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.19894145278572,
      longitude: 16.356126998312025,
    },
  },
  {
    id: '41',
    name: 'Media Quarter Marx Parkgarage',
    street: 'Henneberggasse',
    number: '2-4',
    zip_code: '1030',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.189726490083366,
      longitude: 16.40505551635187,
    },
  },
  {
    id: '42',
    name: 'Media Quarter Marx Parkplatz',
    street: 'Maria-Jacobi-Gasse',
    number: '2',
    zip_code: '1030',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.18853110572543,
      longitude: 16.404239370268183,
    },
  },
  {
    id: '43',
    name: 'Tangente U3 Parkplatz',
    street: 'Im Erdberger Mais',
    number: '3',
    zip_code: '1030',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.19080697638409,
      longitude: 16.412616097048836,
    },
  },
  {
    id: '44',
    name: 'Gesundheitszentrum Favoriten Parkplatz',
    street: 'Wienerbergstraße',
    number: '13-19',
    zip_code: '1100',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.16919737702498,
      longitude: 16.345541453462584,
    },
  },
  {
    id: '45',
    name: 'Votivpark Parkgarage',
    street: 'Universitätsstraße',
    number: '',
    zip_code: '1090',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.214165039619225,
      longitude: 16.36037943637143,
    },
  },
  {
    id: '46',
    name: 'P+R Neulaa Parkplatz',
    street: 'Favoritenstraße/Bahnlände',
    number: '',
    zip_code: '1100',
    city: 'Wien',
    contract_templates: [],
    location: {
      latitude: 48.14722955927468,
      longitude: 16.382694002571267,
    },
  },
];

export const exampleOpenParkingSessions: any[] = [
  {
    id: '1',
    garage_name: exampleGarages[0].name,
    price: { amount: '5', currency: 'EUR' },
    duration_in_seconds: 0,
    start_time: '2021-08-01T12:00:00',
    license_plate: {
      license_plate_country: 'D',
      license_plate: 'ARD:1234',
    },
    type: 'ppu',
  },
  {
    id: '2',
    garage_name: exampleGarages[1].name,
    price: { amount: '10', currency: 'USD' },
    duration_in_seconds: 30 * 60,
    start_time: '2021-08-01T13:00:00',
    license_plate: {
      license_plate_country: 'A',
      license_plate: 'AR:5678',
    },
    type: 'ppu',
  },
  {
    id: '3',
    garage_name: exampleGarages[2].name,
    price: { amount: '15.0', currency: 'EUR' },
    duration_in_seconds: 180 * 60,
    start_time: '2021-08-01T14:00:00',
    license_plate: {
      license_plate_country: 'SRB',
      license_plate: 'AR9012',
    },
    type: 'contract',
  },
];

export const exampleUnpaidParkingSessions: any[] = generateExampleUnpaidParkingSessions(100);

export const exampleBillingInvoices: any[] = generateExampleInvoices(100);

export const exampleArchivedBillingInvoices: any[] = generateExampleArchivedInvoices(12);

export const examplePaymentMethod: any = generateRandomPaymentMethod();

export const exampleVehicles: any[] = [
  {
    id: '1',
    license_plate_country: 'A',
    license_plate: 'G:ARIVO1',
    pay_per_use_enabled: true,
    garage_contracts: [
      {
        id: '1',
        name: 'Testvertrag 1',
        group_limit: 2,
        garage: {
          name: 'Testgarage 1',
        },
      },
      {
        id: '2',
        name: 'Testvertrag 2',
        group_limit: 1,
        garage: {
          name: 'Testgarage 2',
        },
      },
    ],
  },
  {
    id: '2',
    license_plate_country: 'SLO',
    license_plate: 'LJ:577PK',
    pay_per_use_enabled: true,
    garage_contracts: [],
  },
  {
    id: '3',
    license_plate_country: 'A',
    license_plate: 'LI:EBE1',
    pay_per_use_enabled: true,
    garage_contracts: [
      {
        id: '3',
        name: 'Testvertrag 1',
        group_limit: 2,
        garage: {
          name: 'Testgarage 1',
        },
      },
    ],
  },
  {
    id: '4',
    license_plate_country: 'A',
    license_plate: 'SO:NNE1',
    pay_per_use_enabled: false,
    garage_contracts: [],
  },
];

//Factory functions

function generateExampleInvoices(count: number): any[] {
  const invoices: any[] = [];
  const productCategories = ['contract', 'pay_per_use', 'reservation'];
  const currencies = ['EUR'];
  const today = new Date();
  let lastInvoiceRegenerateUrl: string | null = null;

  for (let i = 1; i <= count; i++) {
    let amountPerMonth = Math.floor(3 * Math.random() + 1);
    if (Math.random() < 0.05) {
      amountPerMonth = 0;
    }
    for (let j = 0; j < amountPerMonth; j++) {
      const type = Math.random() < 0.8 ? 'invoice' : 'reversal';
      let randomValue = Math.random();
      let status;
      if (randomValue < 0.7) {
        status = type === 'invoice' ? 'cleared' : 'refunded';
      } else if (randomValue < 0.9) {
        status = type === 'invoice' ? 'open' : 'deducted';
      } else {
        status = type === 'invoice' ? 'uncollectible' : 'nonrefundable';
      }
      let product_category = productCategories[Math.floor(Math.random() * productCategories.length)];
      const invoiceDate = new Date(today);
      invoiceDate.setMonth(today.getMonth() - i);
      invoiceDate.setDate(j + 1);

      const invoice: any = {
        id: i.toString() + '-' + j.toString(),
        invoice_number: `-${i.toString().padStart(3, '0')}-${j.toString().padStart(2, '0')}`,
        invoice_date: invoiceDate.toISOString(),
        invoice_type: type,
        product_category: product_category,
        period_start: new Date(invoiceDate.getFullYear(), invoiceDate.getMonth(), 1).toISOString(),
        period_end: new Date(invoiceDate.getFullYear(), invoiceDate.getMonth() + 1, 1).toISOString(),
        costs: { amount: Math.floor(1000 * Math.random()), currency: currencies[i % currencies.length] },
        fees: null,
        status: status,
        pdf_url: 'https://arivo.co',
        regenerate_url: null,
      };

      invoice.invoice_number = type === 'reversal' ? 'REV' + invoice.invoice_number : 'INV' + invoice.invoice_number;

      if (invoice.invoice_type === 'invoice') {
        if (Math.random() < 0.3) {
          invoice.regenerate_url = `/api/invoice/v2/invoice/${invoice.id}/regenerate_invoice/`;
        }
        lastInvoiceRegenerateUrl = invoice.regenerate_url;
      } else if (lastInvoiceRegenerateUrl && Math.random() < 0.3) {
        invoice.regenerate_url = lastInvoiceRegenerateUrl;
      }

      if (Math.random() < 0.5) {
        invoice.fees = { amount: Math.floor(10 * Math.random()) + 1, currency: currencies[i % currencies.length] };
      }
      invoice.costs.amount = invoice.costs.amount.toString();
      invoices.push(invoice);
    }
  }

  return invoices;
}

function generateExampleArchivedInvoices(count: number): any[] {
  const invoices: any[] = [];
  const today = new Date();

  for (let i = 1; i <= count; i++) {
    const invoiceDate = new Date(today);
    invoiceDate.setMonth(today.getMonth() - i - 12);
    invoiceDate.setDate(1);
    const invoicesPerMonth = i <= 4 ? 3 : 1;

    for (let j = 0; j < invoicesPerMonth; j++) {
      const invoiceDateInMonth = new Date(invoiceDate);
      invoiceDateInMonth.setDate(j + 1);
      const amount = 75 + i * 10 + j * 35;
      const costs = [{ amount: amount.toString(), currency: 'EUR' }];

      if (i <= 2 && j === 0) {
        costs.push({ amount: (amount + 3.18).toFixed(2), currency: 'CHF' });
      }

      const isCancelled = j === 2 || (invoicesPerMonth === 1 && i % 5 === 0);

      invoices.push({
        id: `archived-${i}-${j + 1}`,
        invoice_number: `00-${i * 10 + j + 1}`,
        invoice_date: invoiceDateInMonth.toISOString(),
        invoice_type: 'invoice',
        period_start: new Date(invoiceDate.getFullYear(), invoiceDate.getMonth(), 1).toISOString(),
        period_end: new Date(invoiceDate.getFullYear(), invoiceDate.getMonth() + 1, 0, 23, 59, 59).toISOString(),
        costs,
        status: 'cleared',
        pdf_url: 'https://arivo.co',
      });

      if (isCancelled) {
        const cancellationDate = new Date(invoiceDateInMonth);
        cancellationDate.setDate(cancellationDate.getDate() + 3);

        invoices.push({
          id: `archived-cancellation-${i}-${j + 1}`,
          invoice_number: `0C-${i * 10 + j + 1}`,
          invoice_date: cancellationDate.toISOString(),
          invoice_type: 'reversal',
          period_start: new Date(invoiceDate.getFullYear(), invoiceDate.getMonth(), 1).toISOString(),
          period_end: new Date(invoiceDate.getFullYear(), invoiceDate.getMonth() + 1, 0, 23, 59, 59).toISOString(),
          costs: costs.map((cost) => ({ ...cost })),
          status: 'refunded',
          pdf_url: 'https://arivo.co',
        });
      }
    }
  }

  return invoices;
}

export function generateExampleUnpaidParkingSessions(count: number): any[] {
  const sessions = [];
  const licensePlates = examplePayPerUseLicensePlates;
  const garageNames = exampleGarages.map((garage) => garage.name);
  const currencies = ['EUR'];

  if (licensePlates.length === 0) {
    return [];
  }

  for (let i = 1; i <= count; i++) {
    const date = new Date(2022, 0, 0, 0, 0, 0);
    const entryDate = new Date(2023, 0, i - 1, 10, 0, 0);
    const exitDate = new Date(entryDate);
    exitDate.setHours(entryDate.getHours() + Math.floor(Math.random() * 48) + 1); // Exit time is 1 to 48 hours after entry
    exitDate.setMinutes(Math.floor(Math.random() * 60)); // Exit time is 1 to 24 hours after entry
    date.setFullYear(exitDate.getFullYear());
    date.setMonth(exitDate.getMonth());

    const durationInHours = (exitDate.getTime() - entryDate.getTime()) / (1000 * 60 * 60);
    const priceAmount = (Math.floor(Math.max(1, durationInHours)) * 2.3).toFixed(2);

    const session = {
      id: i.toString(),
      date: date.toISOString(),
      license_plate: licensePlates[Math.floor(Math.random() * licensePlates.length)],
      garage_name: garageNames[Math.floor(Math.random() * garageNames.length)],
      entry_date_time: entryDate.toISOString(),
      exit_date_time: exitDate.toISOString(),
      price: {
        amount: priceAmount.toString(),
        currency: currencies[Math.floor(Math.random() * currencies.length)],
      },
    };
    sessions.push(session);
  }

  return sessions;
}

export function generateRandomPaymentMethod() {
  const cardBrands = ['visa', 'mc', 'amex', 'diners', 'discover', 'jcb', 'default'];
  const paymentTypes: PaymentType[] = ['scheme'];
  const randomCardBrand = cardBrands[Math.floor(Math.random() * cardBrands.length)];
  const randomPaymentType: PaymentType = paymentTypes[Math.floor(Math.random() * paymentTypes.length)];

  return {
    type: randomPaymentType,
    brand: randomPaymentType === 'scheme' ? randomCardBrand : undefined,
    card_summary: randomPaymentType === 'scheme' ? '0000' : undefined,
  };
}

export function addRandomProductsToGarages(garages: any[]): void {
  garages.forEach((garage) => {
    // const numberOfProducts = Math.floor(Math.random() * 3) + 1; // Random number between 1 and 3
    const numberOfProducts = Math.floor(Math.random() * (exampleProducts.length + 1)); // Random number between 0 and maxProducts
    const selectedProducts: any[] = [];
    const availableProducts = [...exampleProducts]; // Create a copy of exampleProducts

    while (selectedProducts.length < numberOfProducts && availableProducts.length > 0) {
      const randomIndex = Math.floor(Math.random() * availableProducts.length);
      const randomProduct = JSON.parse(JSON.stringify(availableProducts.splice(randomIndex, 1)[0])); // Remove the product from availableProducts and create a deep copy
      randomProduct.id = `${garage.id}-${randomProduct.id}`; // Add garage ID as prefix
      randomProduct.initial_start = '2024-10-10T00:00:00';
      selectedProducts.push(randomProduct);
    }

    garage.contract_templates = selectedProducts;
  });
}

export function addRandomBillingAddressesToGarages(garages: any[]) {
  const billingAddresses = [
    {
      name: 'Max Mustermann',
      address1: 'Kurzweg 12',
      zip_code: '76149',
      city: 'Karlsruhe',
      country: {code: 'DE', name: 'Germany'},
      address_type: 'primary'
    },
    {
      name: 'Erika Musterfrau',
      address1: 'Musterstraße 45',
      address2: '2. OG',
      zip_code: '80331',
      city: 'München',
      country: {code: 'DE', name: 'Germany'},
      address_type: 'secondary'
    },
    {
      name: 'Beispiel GmbH',
      address1: 'Hauptstraße 7',
      zip_code: '10115',
      city: 'Berlin',
      country: {code: 'DE', name: 'Germany'},
      address_type: 'pseudo'
    },
  ];
  garages.forEach((garage) => {
    const randomIndex = Math.floor(Math.random() * billingAddresses.length);
    garage.billing_address = billingAddresses[randomIndex];
  })
}

export function generateRandomOpenParkingSessions(count: number): any[] {
  if (exampleLicensePlates.length === 0) {
    return [];
  }

  const sessions = [];
  const currency = 'EUR';
  const types = ['ppu', 'contract'];

  for (let i = 0; i < count; i++) {
    const randomGarage = exampleGarages[Math.floor(Math.random() * exampleGarages.length)];
    const randomLicensePlate = exampleLicensePlates[Math.floor(Math.random() * exampleLicensePlates.length)];
    const randomType = types[Math.floor(Math.random() * types.length)];
    const randomStartTime = new Date(Date.now() - Math.floor(Math.random() * 7 * 24 * 60 * 60 * 1000)).toISOString(); // Random start time within the last 30 days
    const durationInSeconds = Math.floor((Date.now() - new Date(randomStartTime).getTime()) / 1000); // Duration from start time until now
    const durationInHours = durationInSeconds / 3600;
    const priceAmount = parseFloat((durationInHours * 1.1).toFixed(2)); // Price based on duration

    const session = {
      id: (i + 1).toString(),
      garage_name: randomGarage.name,
      price: { amount: priceAmount.toString(), currency: currency },
      duration_in_seconds: durationInSeconds,
      start_time: randomStartTime,
      license_plate: {
        license_plate_country: randomLicensePlate.license_plate_country,
        license_plate: randomLicensePlate.license_plate,
      },
      type: randomType,
    };

    sessions.push(session);
  }

  return sessions;
}

const austrianGeneralData: ProviderGeneralDataApiResponse = {
  contact_phone_number: '+43 1 2345678',
  contact_email: 'info@example.at',
  default_currency: 'EUR',
  primary_address: {
    address1: 'Example Provider Street 1',
    name: 'Example Company Austria Headquarters',
    representative: 'Jane Doe',
    zip_code: '1010',
    city: 'Vienna',
    country: {"code": "AT", "name": "Austria"},
    address_type: "primary",
    vat_id: 'ATU12345678',
    jurisdiction: 'Handelsgericht Wien',
    register_number: 'FN 123456a',
  },
  secondary_addresses: [
    {
      address1: 'Example Street 2',
      name: 'Example Branch Germany',
      representative: 'John Doe',
      zip_code: '10115',
      city: 'Berlin',
      country: {"code": "DE", "name": "Germany"},
      address_type: "secondary",
    },
    {
      address1: 'Example Street 3',
      address2: 'Suite 100',
      name: 'Example Branch USA',
      zip_code: '10001',
      city: 'New York',
      country: {"code": "US", "name": "United States"},
      address_type: "secondary",
    }
  ]
};

// const germanGeneralData: ProviderGeneralData = {
//   name: 'Example Company Germany',
//   representative: 'Jane Doe',
//   address: 'Example Street 3',
//   zip_code: '10115',
//   city: 'Berlin',
//   country: 'Germany',
//   contact_phone_number: '+49 30 1234567',
//   contact_email: 'info@example.de',
//   vat_id: 'DE123456789',
//   jurisdiction: 'Amtsgericht Berlin',
//   register_number: 'HRB 123456',
// };

export const exampleProviderSettings: ProviderSettingsApiResponse = {
  website_title: 'Example Serviceportal',
  general_data: austrianGeneralData,
  // general_data: germanGeneralData,
  links: {
    // terms_and_conditions: { title: 'example_terms', url: 'https://www.example-provider.com/terms' },
    // privacy_policy: { title: 'example_privacy_policy', url: 'https://www.example-provider.com/privacy' },
    // imprint: { title: 'example_imprint', url: 'https://www.example-provider.com/imprint' },
    // arbitration_board: { title: 'example_arbitration_board', url: 'https://www.example-provider.com/arbitration' },
    // accessibility: { title: 'example_accessibility', url: 'https://www.example-provider.com/accessibility' },
  },
  images: {
    logo: {
      url: 'data:image/png;base64,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',
    },
    logo_large: {
      url: 'data:image/png;base64,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',
    },
    favicon: {
      url: 'data:image/x-icon;base64,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',
    },
    pay_per_use_logo: {
      url: 'data:image/svg+xml;base64,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',
      alt_text: 'WIPcard logo',
    },
  },
  feature_flags: {
    // enable_marketing_consent: false,
    // enable_contract_creation_dashboard: false,
    // enable_contract_creation_products: false,
    // enable_contract_termination: false,
    // enable_contract_qr_code: false,
    // door_opener_qr_code: false,
    // enable_app_and_notifications: false,
    // enable_cookie_consent: false,
    // enable_contract_reference: true,
    enable_voucher: true,
    // enable_external_billing: true,
    // enable_ppu: false,
  },
};

export const exampleContractRequests: any[] = [
  {
    id: '1',
    status: 'pending',
    garage: {
      name: 'Freyung Parkgarage',
      street: 'Herrengasse',
      number: '',
      zip_code: '1010',
      city: 'Wien',
    },
    name: 'Super Vertrag beantragen (Beispielvertrag)',
    group_limit: 3,
    license_plates: [...exampleLicensePlates],
    start: '2024-06-01',
    price: {
      amount: 10,
      currency: 'EUR',
    },
  },
  {
    id: '2',
    status: 'waiting_list',
    garage: {
      name: 'Freyung Parkgarage',
      street: 'Herrengasse',
      number: '',
      zip_code: '1010',
      city: 'Wien',
    },
    name: 'Super Vertrag beantragen (Beispielvertrag)',
    group_limit: 1,
    license_plates: [...exampleLicensePlates],
    start: '2024-06-01',
    price: {
      amount: 15,
      currency: 'EUR',
    },
  },
    {
    id: '3',
    status: 'declined',
    garage: {
      name: 'Freyung Parkgarage',
      street: 'Herrengasse',
      number: '',
      zip_code: '1010',
      city: 'Wien',
    },
    name: 'Super Vertrag beantragen (Beispielvertrag)',
    group_limit: 2,
    license_plates: [],
    start: '2024-06-01',
    price: {
      amount: 20,
      currency: 'EUR',
    },
  },
];




export const exampleVouchers: Voucher[] = [
  {
    id: '1',
    name: 'Resident',
    code: 'XYCXYCDAFSA',
    type: 'single',
    amount: 5,
    amount_type: 'A',
    used: new Date().toISOString(),
    status: 'used',
    currency: 'EUR',
    timezone: 'Europe/Vienna',
    target_invoice_type: 'all',
  }, 
    {
    id: '2',
    name: 'Summer Promo',
    code: 'SUMMER2026',
    type: 'multiple',
    amount: 15,
    amount_type: 'P',
    used: new Date(2026, 3, 26).toISOString(),
    billed: new Date(2026, 4, 1).toISOString(),
    status: 'billed',
    currency: 'CHF',
    timezone: 'Europe/Vienna',
    target_invoice_type: 'contract',
  }, 
    {
    id: '3',
    name: 'Summer Promo',
    code: 'SUMMER2024',
    type: 'single',
    amount: 25,
    amount_type: 'A',
    used: new Date(2026, 9, 15).toISOString(),
    billed: new Date(2026, 10, 1).toISOString(),    
    status: 'billed',
    currency: 'EUR',
    timezone: 'Europe/Vienna',
    target_invoice_type: 'pay_per_use',
  }, 
]


export const unusedExampleVouchers: Voucher[] = [
    {
    id: '4',
    name: 'Valid Multiple',
    code: 'valid-multiple',
    type: 'multiple',
    amount: 1,
    amount_type: 'A',
    used: new Date().toISOString(),
    status: 'billed',
    currency: 'EUR',
    timezone: 'Europe/Vienna',
    target_invoice_type: 'contract',
  }, 
    {
    id: '5',
    name: 'Valid Single',
    code: 'valid-single',
    type: 'single',
    amount: 5,
    amount_type: 'A',
    used: new Date().toISOString(),
    currency: 'EUR',
    status: 'used',
    timezone: 'Europe/Vienna',
    target_invoice_type: 'all',
  }, 
]





